import { ProductSeed } from 'base/types/Products';
import { CropConstants } from './constants/Crop';

export const getDefaultSku = (item: any) => {
  const defaultSku = item.sku?.find((sku: any) => sku.defaultSku && sku.available);
  return defaultSku || item.sku?.find((sku: any) => sku.bagSize !== null) || [];
};

export const convertSeedsToBagsForProduct = (
  seedingRate: number,
  areaApplied: number,
  product: ProductSeed | undefined,
  countryCode?: string | null
): number => {
  // For Netherlands, never use SKU, always use 50,000 as bag size
  if (product && countryCode === CropConstants.NETHERLANDS_CODE) {
    const bagSize = CropConstants.NETHERLANDS_BAG_SIZE;
    const seedRateFromProductApi =
      product.crop.id === CropConstants.BARLEY_CROP_ID
        ? Number(product.defaultSeedingRate)
        : seedingRate;
    return (Number(seedRateFromProductApi) * Number(areaApplied)) / bagSize;
  }

  // Only check SKUs for countries other than Netherlands
  if (product && countryCode !== CropConstants.NETHERLANDS_CODE && product?.sku?.length > 0) {
    const sku = getDefaultSku(product) || product.sku?.[0];
    if (!sku?.bagSize) {
      return 0;
    }

    const bagSize = Number(sku.bagSize);

    const seedRateFromProductApi =
      product.crop.id === CropConstants.BARLEY_CROP_ID
        ? Number(product.defaultSeedingRate)
        : seedingRate;
    return bagSize === 0
      ? bagSize
      : (Number(seedRateFromProductApi) * Number(areaApplied)) / bagSize;
  }
  return 0;
};
